import { Paragraph, SizableText, Slider, useEvent, XStack, YStack } from 'tamagui'
import * as Branding from '@/src/experiences/branding'
import { formatCurrency } from '@/src/common/utils/general'

export function PurchaseForm({
  purchaseAmount,
  downPaymentAmount,
  onChange,
}: {
  purchaseAmount: number
  downPaymentAmount: number
  onChange: (purchaseAmount: number, downPaymentAmount: number) => void
}) {
  const { token: primaryColorToken } = Branding.Hooks.usePrimaryColor()
  const handleChangePurchaseAmount = useEvent((values: number[]) => {
    onChange(values[0] ?? purchaseAmount, downPaymentAmount)
  })
  const handleChangeDownPaymentAmount = useEvent((values: number[]) => {
    onChange(purchaseAmount, values[0] ?? downPaymentAmount)
  })
  return (
    <YStack gap="$4">
      <YStack>
        <Paragraph fontSize={16} color="$textSubtle">
          Purchase Amount
        </Paragraph>
        <XStack items="center" gap="$2">
          <Slider
            value={[purchaseAmount]}
            onValueChange={handleChangePurchaseAmount}
            min={100_000}
            max={2_000_000}
            flex={1}
            step={25_000}
          >
            <Slider.Track>
              <Slider.TrackActive backgroundColor={primaryColorToken} />
            </Slider.Track>
            <Slider.Thumb size="$1" circular index={0} />
          </Slider>
          <SizableText size="$3" width={80} text="right">
            {formatCurrency(purchaseAmount, {
              decimals: 0,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </SizableText>
        </XStack>
      </YStack>
      <YStack>
        <Paragraph fontSize={16} color="$textSubtle">
          Down Payment ({downPaymentAmount}%)
        </Paragraph>
        <XStack items="center" gap="$2">
          <Slider
            value={[downPaymentAmount]}
            onValueChange={handleChangeDownPaymentAmount}
            min={5}
            max={95}
            flex={1}
            step={5}
          >
            <Slider.Track>
              <Slider.TrackActive backgroundColor={primaryColorToken} />
            </Slider.Track>
            <Slider.Thumb size="$1" circular index={0} />
          </Slider>
          <SizableText size="$3" width={80} text="right">
            {formatCurrency((purchaseAmount * downPaymentAmount) / 100, {
              decimals: 0,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </SizableText>
        </XStack>
      </YStack>
    </YStack>
  )
}
